import { onChangeDevMode } from './dev-mode';

// Logger utility that only logs when the app is in dev mode

let devMode;
onChangeDevMode((value) => {
    devMode = value;
});

const createLogger = ({
    cmd = 'log',
    prefix = '',
    backgroundColor = 'black',
    textColor = 'white',
    enabled = true,
} = {}) => {
    let forceEnabled;
    const style = `background-color: ${backgroundColor}; color: ${textColor}; padding: 1px 2px`;
    const log = (...args) => {
        if ((devMode && enabled) || forceEnabled) {
            console[cmd](`%c${prefix}`, style, ...args);
        }
        forceEnabled = false;
    };
    log.force = (value) => {
        forceEnabled = value;
        return log;
    };

    log.enable = () => {
        enabled = true;
    };

    log.disable = () => {
        enabled = false;
    };

    log.setEnabled = (value) => {
        enabled = !!value;
    };

    return log;
};
export default createLogger;
